<template>
  <QFooter class="bg-white text-primary shadow-soft app-mobile-footer">
    <QTabs v-if="!isMasterEtabWithoutSupervisedEtab" switch-indicator>
      <QRouteTab
        :name="ETAB_ROUTES.dashboard.tabs.root.name"
        icon="icon-f-layers"
        no-caps
        :to="{ name: ETAB_ROUTES.dashboard.tabs.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@RECRUITMENTS')"
      />
      <QRouteTab
        :name="ETAB_ROUTES.creation.root.name"
        icon="icon-f-plus-circle"
        no-caps
        :to="{ name: ETAB_ROUTES.creation.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@SEARCH')"
      />
      <QRouteTab
        :name="ETAB_ROUTES.userMenu.root.name"
        icon="icon-f-user"
        no-caps
        :to="{ name: ETAB_ROUTES.userMenu.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ACCOUNT')"
      />
      <QRouteTab
        v-if="isMasterEtabWithSupervisedEtab"
        :name="ETAB_ROUTES.account.multiAccount.name"
        icon="icon-extra-multi-etab"
        no-caps
        :to="{ name: ETAB_ROUTES.account.multiAccount.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ETABLISSEMENTS')"
      />
    </QTabs>
    <QTabs v-if="isMasterEtabWithoutSupervisedEtab" switch-indicator>
      <QRouteTab
        :name="ETAB_ROUTES.userMenu.root.name"
        icon="icon-f-user"
        no-caps
        :to="{ name: ETAB_ROUTES.userMenu.root.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ACCOUNT')"
      />
      <QRouteTab
        :name="ETAB_ROUTES.dashboard.tabs.root.name"
        icon="icon-extra-multi-etab"
        no-caps
        :to="{ name: ETAB_ROUTES.account.multiAccount.name }"
        :label="$t('ETAB.LAYOUTS.DASHBOARD.@ETABLISSEMENTS')"
      />
    </QTabs>
  </QFooter>
</template>

<script>
  import { ETAB_ROUTES } from "@etab/config";
  import { CORE_EVENTS, ROLE } from "@core/constants";
  import { EventManager } from "@core/managers/event.manager";
  import { UserStorageManager } from "@core/managers/user-storage.manager";

  export default {
    data() {
      return {
        hasSupervisedEtab: undefined,
        masterEtab: false,
      };
    },
    computed: {
      isMasterEtabWithoutSupervisedEtab() {
        return this.masterEtab && !this.hasSupervisedEtab;
      },
      isMasterEtabWithSupervisedEtab() {
        return this.masterEtab && this.hasSupervisedEtab;
      },
    },
    created() {
      this.ETAB_ROUTES = ETAB_ROUTES;
      EventManager.on(CORE_EVENTS.ON_LOGIN, this.isMasterEtab);
      this.isMasterEtab();
      this.hasCurrentSupervisedEtab();
    },
    methods: {
      async hasCurrentSupervisedEtab() {
        this.hasSupervisedEtab = !!(await UserStorageManager.getSupervisorData());
      },
      async isMasterEtab() {
        const user = await UserStorageManager.getUser();
        if (user) {
          const role = user.role[0];
          if (role === ROLE.MASTER) {
            this.masterEtab = true;
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  .app-mobile-footer {
    .q-tab {
      width: 31%;
    }
  }
</style>
